// /waitlist-invite → /signup redirect. The server's waitlist emails link
// here (buildInviteUrl('waitlist-invite', token)); a waitlist invitee has
// no account by definition, so the right landing is the SIGNUP flow with
// the token preserved — signup.js already consumes `?token=` (seeds the
// email field and passes it to sdk.register as `inviteToken`, which the
// server exchanges for a trusted, pre-verified signup + waitlist-entry
// onboarding). Same tiny redirect-page convention as logs-redirect.
import { withLiveQuery } from '../../functions/bootRedirectQuery.js'
import { authPageTheme } from './theme.js'

export const waitlistInvite = {
  extends: 'Page',
  metadata: (el) => ({ title: el.call('polyglot', 'auth.page.waitlistInvite.title') }),
  flow: 'y',
  align: 'center center',
  padding: 'D C',
  width: '100%',
  height: '100dvh',
  maxWidth: 'none',
  ...authPageTheme,

  onCreate: (el) => {
    if (typeof window === 'undefined') return
    try {
      // Carry the WHOLE query through (token + any campaign params) via the
      // shared helper — tickets/sonnet.md "auth-page redirects still drop
      // the query": this used to hand-roll `+ search` itself, the one site
      // that already knew the query had to be carried while every other
      // auth redirect dropped it. Routed through `withLiveQuery` now so
      // there is exactly one mechanism for this, not two.
      el.router(withLiveQuery('/signup'), el.getRoot())
    } catch (err) {
      window.location.replace('/signup')
    }
  },

  Notice: {
    tag: 'span',
    fontSize: 'Y',
    color: 'caption',
    text: '{{ auth.waitlistInvite.opening | polyglot }}'
  }
}
